/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import * as components from "../components/index.js";

export type PreviewEquipmentBrowserViewRequest = {
  agentId: string;
  body: components.PreviewEquipmentBrowserViewRequestBody;
};

/** @internal */
export type PreviewEquipmentBrowserViewRequest$Outbound = {
  agent_id: string;
  body: components.PreviewEquipmentBrowserViewRequestBody$Outbound;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequest$outboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequest$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBrowserViewRequest
> = z.object({
  agentId: z.string(),
  body: components.PreviewEquipmentBrowserViewRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function previewEquipmentBrowserViewRequestToJSON(
  previewEquipmentBrowserViewRequest: PreviewEquipmentBrowserViewRequest,
): string {
  return JSON.stringify(
    PreviewEquipmentBrowserViewRequest$outboundSchema.parse(
      previewEquipmentBrowserViewRequest,
    ),
  );
}
